// Cookie 过期时间
export const COOKIE_MAX_AGE = 60 * 60 * 24 * 400 // 400 天
